import { useLocation } from '@tanstack/react-router';
import { APP_COUNTRY } from 'config';
import { useStore } from 'react-redux';
import { selectSessionInfo } from 'services/session/session.selectors';
import { AppChannel } from 'utils/config.config';

export const useShowFooterOnAppSeu = () => {
  const reduxStore = useStore();
  const { channel } = selectSessionInfo(reduxStore.getState());
  const isSeu = APP_COUNTRY?.toLowerCase() !== 'it';
  const { pathname } = useLocation();
  const footerOnAppSeu =
    !pathname?.includes('topup') ||
    !pathname?.includes('withdrawal') ||
    !pathname?.includes('topup-done') ||
    !pathname?.includes('withdrawal-done');
  return isSeu && channel == AppChannel.AppSisalPoker && footerOnAppSeu;
};
